/**
 * Only http(s) links reach an href. Reference URLs come from decks that can be edited or imported by hand, and the
 * schema accepts any URL (javascript:, data:), so every external link is checked where it's rendered.
 */
export function safeHref(url: string): string | undefined {
  try {
    const u = new URL(url);
    return u.protocol === "https:" || u.protocol === "http:" ? u.href : undefined;
  } catch {
    return undefined;
  }
}

/** Where to go after signing in: a path on this site, never another origin (`/\evil.com`, tabs, `//`). */
export function safeNext(next: string | null, fallback = "/studio"): string {
  if (!next || !next.startsWith("/")) return fallback;
  try {
    const u = new URL(next, window.location.origin);
    return u.origin === window.location.origin ? `${u.pathname}${u.search}${u.hash}` : fallback;
  } catch {
    return fallback;
  }
}
